import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

export default function NotFoundPage() {
  return (
    <div className="bg-stone-100 min-h-[75vh] flex items-center justify-center pt-36 sm:pt-44 pb-20 px-4">
      <PageSEO
        title="404 - Siden blev ikke fundet | KTS-Entreprise A/S"
        description="Den side du leder efter findes desværre ikke på KTS-Entreprise A/S."
        slug="404"
      />

      <div className="max-w-xl w-full bg-white border-2 border-stone-300 p-8 sm:p-12 shadow-sm text-center">
        <div className="w-16 h-16 bg-stone-900 text-[#0072c0] font-heading font-black text-2xl flex items-center justify-center mx-auto mb-6">
          404
        </div>

        <h1 className="text-3xl font-black uppercase text-stone-900 tracking-tight font-heading mb-3">
          Siden blev ikke fundet
        </h1>

        <p className="text-stone-600 text-sm leading-relaxed mb-8">
          Beklager, den side du forsøger at tilgå eksisterer ikke eller er blevet flyttet. Brug genvejene herunder til at komme videre.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-xs font-heading font-bold uppercase tracking-wider">
          <Link
            to="/"
            className="bg-[#0072c0] hover:bg-[#005b99] text-white py-3 px-4 transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house"></i>
            <span>Gå til Forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="bg-stone-900 hover:bg-stone-800 text-white py-3 px-4 transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-envelope"></i>
            <span>Kontakt os</span>
          </Link>
        </div>

        <div className="border-t border-stone-200 pt-6 text-xs text-stone-500 space-y-2 text-left">
          <span className="font-bold uppercase tracking-wider block font-heading text-stone-700">
            Populære ydelser:
          </span>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Link to="/entreprenerservice" className="hover:text-[#0072c0] underline">• Entreprenør og anlæg</Link>
            <Link to="/kloak-service" className="hover:text-[#0072c0] underline">• Kloak og klimasikring</Link>
            <Link to="/tv-inspektion" className="hover:text-[#0072c0] underline">• TV-inspektion og spuling</Link>
            <Link to="/betonarbejde" className="hover:text-[#0072c0] underline">• Betonarbejde</Link>
            <Link to="/udlejning" className="hover:text-[#0072c0] underline">• Udlejning</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
